import { ICommand } from './ICommand';
import { useDiagramStore } from '../../stores/diagramStore';
import { Node, Edge } from '../models/scene';
import { Clipboard } from '../clipboard/Clipboard';
import { buildClipboardSelection, hasClipboardContent } from '../clipboard/clipboardSelection';

export class CopyNodeCommand implements ICommand {
  id: string;
  name = 'Copy Nodes';
  description: string;
  timestamp = Date.now();
  
  private sourceNodeIds: string[];
  constructor(sourceNodeIds: string[], offset?: { x: number; y: number }) {
    void offset;
    this.id = `copy-nodes-${Date.now()}`;
    this.sourceNodeIds = sourceNodeIds;
    this.description = sourceNodeIds.length === 1 
      ? 'Copy node' 
      : `Copy ${sourceNodeIds.length} nodes`;
  }
  
  async execute(): Promise<void> {
    const store = useDiagramStore.getState();
    const { nodes: copiedNodes, edges: copiedEdges } = buildClipboardSelection({
      selectedIds: this.sourceNodeIds,
      nodes: store.nodes,
      edges: store.edges,
    }) as { nodes: Node[]; edges: Edge[] };

    if (!hasClipboardContent({ nodes: copiedNodes, edges: copiedEdges })) {
      return;
    }

    Clipboard.set(copiedNodes, copiedEdges);

    try {
      await Clipboard.writeToSystem(copiedNodes, copiedEdges);
    } catch {
      // Ignore clipboard sync failures; in-memory clipboard still works
    }
  }
  
  undo(): void {
    // Copy does not mutate model state anymore; nothing to undo
  }
  
  redo(): Promise<void> {
    return this.execute();
  }
}
